import api from './api';
import { ApiResponse } from '../types/common';
import { LoginRequest, LoginResponse } from '../types/auth';

export const authService = {
  // 로그인
  login: async (data: LoginRequest): Promise<ApiResponse<LoginResponse>> => {
    const response = await api.post('/api/login', data);
    return response.data;
  },

  // 로그아웃
  logout: async (): Promise<ApiResponse<null>> => {
    const response = await api.post('/api/logout');
    return response.data;
  },

  // 세션 확인
  checkSession: async (): Promise<ApiResponse<LoginResponse>> => {
    const response = await api.get('/api/check-session');
    return response.data;
  },
};
